import React from "react";
import Button from "../../common/button/button";

export function BotaoEditarCampoUc(props) {
    const estilo = props.style || {};
    return (
        <table style={{ width: "100%" }}>
            <tbody>
                <tr>
                    <td colSpan={props.campoEdicao === props.nomeCampo ? 1 : 2}>
                        <Button
                            style={estilo}
                            solid={true}
                            icon={`fas fa-${props.campoEdicao === props.nomeCampo ? "check" : "pencil-alt"}`}
                            disabled={props.campoEdicao && !props.campoEdicao === props.nomeCampo}
                            type={props.campoEdicao === props.nomeCampo ? "success" : "info"}
                            event={() => {
                                if (props.campoEdicao === props.nomeCampo) {
                                    props.eventoSalvar();
                                } else if (!props.campoEdicao) {
                                    props.eventoEditar();
                                }
                            }}
                        />
                    </td>
                    <td>{props.campoEdicao === props.nomeCampo && <Button style={estilo} solid={true} icon={`fas fa-times`} type={"danger"} event={props.eventoCancelar} />}</td>
                </tr>
            </tbody>
        </table>
    );
}
